export enum DataHooks {
  WeekAvailability = 'week-availability',
  Loader = 'loader',
  DayAvailability = 'day-availability',
  DayDetails = 'day-details',
}
